import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GerenciadorPrecos } from '../../../../@types/GerenciadorPrecos';
import { RootState } from '../../../../@types/RootState';

type DemandForecastState = {
  isOpen: boolean;
  data: GerenciadorPrecos.RowData['demandForecast'] | null;
  selectedForecastIndex: number | null;
};

const initialState: DemandForecastState = {
  isOpen: false,
  data: null,
  selectedForecastIndex: null,
};

const slice = createSlice({
  name: 'ipa.priceManager.modals.demandForecast',
  initialState,
  reducers: {
    SET_IS_OPEN(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    SET_DATA(state, action: PayloadAction<DemandForecastState['data']>) {
      state.data = action.payload;
    },
    SET_INDEX(state, action: PayloadAction<number | null>) {
      state.selectedForecastIndex = action.payload;
    },
  },
});

export const { SET_IS_OPEN, SET_DATA, SET_INDEX } = slice.actions;

export default slice.reducer;

export const selectorDemandForecast = (state: RootState) => {
  return state.ipa.priceManager.modals.demandForecast;
};
